export function dateFormat(stamp, format) {
    if (!stamp) {
        return ''
    } else {
        const t = new Date(stamp)
            // 日期格式 大写补0，小写不补0
        format = format || 'Y-m-d h:i:s'
        let year = t.getFullYear()
            // 由于 getMonth 返回值会比正常月份小 1
        let month = t.getMonth() + 1
        let day = t.getDate()
        let hours = t.getHours()
        let minutes = t.getMinutes()
        let seconds = t.getSeconds()

        const hash = {
                'y': year,
                'm': month,
                'd': day,
                'h': hours,
                'i': minutes,
                's': seconds
            }
            // 是否补 0
        const isAddZero = (o) => {
            return /M|D|H|I|S/.test(o)
        }
        return format.replace(/\w/g, o => {
            let rt = hash[o.toLocaleLowerCase()]
            return rt >= 10 || !isAddZero(o) ? rt : `0${rt}`
        })
    }
}

//meta标签  栏目
export function createColumnMeta(columnName) {
    let head = document.getElementsByTagName('head')
    let nameList = ['ColumnName', 'ColumnDescription', 'ColumnKeywords', 'ColumnType', 'keywords', 'description']
    let metaList = document.getElementsByTagName('meta')
    let hasMeta = false
    for (let i = 0; i < metaList.length; i++) {
        if (metaList[i].name === 'ColumnName') {
            hasMeta = true
            break
        }
    }
    if (!hasMeta) {
        nameList.forEach(el => {
            let meta = document.createElement('meta')
            meta.name = el
            meta.content = columnName
            head[0].appendChild(meta)
        })
    }
}

//meta标签  内容页
export function createContentMeta(options) {
    let head = document.getElementsByTagName('head')
    let nameList = ['ColumnName', 'ColumnType', 'ArticleTitle', 'PubDate', 'ContentSource', 'Author']
    nameList.forEach(el => {
        let meta = document.createElement('meta')
        meta.name = el
        meta.content = options[el]
        head[0].appendChild(meta)
    })
}